
const commitmentsTabType = {
	TEAM: "TEAM",
	ONE_ON_ONE: "ONE_ON_ONE",
	MEETING_SERIES: "MEETING_SERIES",
	AD_HOC_MEETING: "AD_HOC_MEETING",
};

export default Object.freeze( commitmentsTabType );



// WEBPACK FOOTER //
// ./src/constants/CommitmentsTabType.js